import { Component, OnInit } from '@angular/core';

import { getConfigByAppId } from '@vantage-platform/cards-ui';
import { ICard } from '@vantage-platform/store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: './share-card.component.html',
  styleUrls: ['./share-card.component.scss'],
})
export class ShareCardComponent implements OnInit {
  card: ICard;

  constructor(private translate: TranslateService) {
    const exportData = window['export'];
    this.card = (typeof exportData === 'string'
      ? JSON.parse(exportData)
      : exportData
    ).buckets.card;
  }

  ngOnInit(): void {
    window['exportReady'] = true;
    window.dispatchEvent(new Event('export.ready'));
  }

  getCardConfig(card: ICard) {
    if (card.appID) {
      return getConfigByAppId(card.appID, this.translate, card);
    }
  }
}
